<template>
  <v-row no-gutters justify="space-between" class="rowContent mt-0">
    <!-- avatar -->
    <v-col cols="10">
      <div class="d-flex avatarBox">
        <AvatarComponent
          size="42"
          :url="item.profile ? item.profile.picture : item.course.picture"
        />
        <HeaderThumb :vlog="item" />
      </div>
    </v-col>
    <!-- menu -->
    <v-menu
      left bottom offset-y
      class="postContent__menu"
      v-model="isOpened"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon plain v-bind="attrs" v-on="on">
          <v-icon class="fas fa-ellipsis"></v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-if="item.canDelete"
          @click="deletePost(item)"
        >
          <v-list-item-title class="cursorPointer">
            <v-icon class="fas fa-trash-can pr-2" size="15"></v-icon>
            <translate>Delete post</translate>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="item.canUpdate"
          @click="$store.dispatch('post/openEditPostForm', item)"
        >
          <v-list-item-title class="cursorPointer">
            <v-icon class="fas fa-pen pr-2" size="15"></v-icon>
            <translate>Edit post</translate>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="!item.canUpdate"
          @click="reportPost(item.id)"
        >
          <v-list-item-title class="cursorPointer">
            <v-icon class="fas fa-circle-exclamation pr-2" size="15"></v-icon>
            <translate>Report</translate>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-row>
</template>
<script>
import HeaderThumb from "@/components/Thumbnails/HeaderThumb";
export default {
  props: {
    item: { type: Object, default: {} }
  },
  components: { HeaderThumb },
  data() {
    return {
      isOpened: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    async deletePost(post) {
      const result = await this.$store.state.toggle.dialogConfirm.open(
        this.$gettext("Confirm your action"),
        this.$gettext('Do you want to delete this post ?'),
        { color: "warning" }
      );
      if (!result) return
      if(post.type === POST_TYPE_REVIEW) {
        await this.$store.dispatch("deleteCourseReview", post.id);
      } else {
        await this.$store.dispatch("post/deletePost", post.id);
      }
      this.isOpened = false;
      this.$emit("delete", post.id);
    },
    async reportPost(id) {
      if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      } else {
        this.$store.dispatch("setReport", {
        entityId: id,
        entityName: "post",
        });
      }
    },
  }
};
</script>
